import React from 'react';
import Select from 'components/input/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from 'components/tooltip/Tooltip';

export interface CustomSelectItem {
  key: string;
  label: string;
  toolTipVal?: string;
}

interface CustomSelectType {
  value: string;
  items: CustomSelectItem[];
  onChange: any;
  displayEmpty?: boolean;
  dataTestId?: string;
  className?: string;
  hiddenItems?: string[];
  render: boolean;
}

const CustomSelect: React.FC<CustomSelectType> = props => {
  const { value, items, onChange, displayEmpty, dataTestId, className, hiddenItems, render } = props;

  return (
    <>
      {render && (
        <Select
          className={className}
          data-testid={dataTestId}
          onChange={event => onChange(event.target.value)}
          value={value}
          displayEmpty={displayEmpty}
        >
          {items.map(item => {
            if (!hiddenItems?.includes(item.key)) {
              return (
                <MenuItem value={item.key} key={item.key}>
                  {item.toolTipVal ? (
                    <Tooltip title={item.toolTipVal} arrow>
                      <span>
                        <ListItemText primary={item.label} />
                      </span>
                    </Tooltip>
                  ) : (
                    <ListItemText primary={item.label} />
                  )}
                </MenuItem>
              );
            }
            return null;
          })}
        </Select>
      )}
    </>
  );
};

export default CustomSelect;
